import { useState, useEffect } from "react";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";

import { format } from "date-fns";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

import { useAuth } from "context/AuthContext";
import { useLoading } from "context/LoadingContext";
import { useNotification } from "context/NotificationContext";

import Api from "utils/Api";
import MaskEnum from "utils/MaskEnum";
import MaskUtil from "utils/MaskUtil";
import useQuery from "utils/useQuery";

import ModalAlocacao from "./modules/ModalAlocacao";
import ModalNovoAcesso from "./modules/ModalNovoAcesso";
import ModalOcorrencias from "./modules/ModalOcorrencias";
import ModalPermissoes from "./modules/ModalPermissoes";

// Estilos CSS inline
const styles = {
  funcionarioCard: {
    transition: 'all 0.3s ease',
    border: '1px solid #e9ecef',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  funcionarioCardHover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
  },
  secaoHeader: {
    borderBottom: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  badge: {
    fontSize: '0.75rem',
    fontWeight: '500'
  }
};

const ListaFuncionarioContratadosAlocados = () => {
  const query = useQuery();
  const { setLoading } = useLoading();
  const auth = useAuth();
  const Requicicao = new Api();
  const notify = useNotification();
  const navigate = useNavigate();
  const location = useLocation();

  const { StatusFuncionario } = MaskEnum;
  const StateDatafilter = {
    global: { value: null, matchMode: "contains" },
    nome: {
      operator: "and",
      constraints: [{ value: null, matchMode: "startsWith" }]
    },
    cpf: {
      operator: "and",
      constraints: [{ value: null, matchMode: "startsWith" }]
    }
  };

  const [Lista, setLista] = useState([]);
  const [filters, setFilters] = useState(StateDatafilter);
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  // Estados para view mode e filtros avançados
  const [viewMode, setViewMode] = useState("list");
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [selectedStatusCadastro, setSelectedStatusCadastro] = useState([]);
  const [selectedStatusFuncionario, setSelectedStatusFuncionario] = useState([]);

  const [empresaId, setEmpresaId] = useState("");
  const [matriz, setMatriz] = useState("");

  const [ShowModalNovoAcesso, setShowModalNovoAcesso] = useState(false);
  const [DadosAcesso, setDadosAcesso] = useState(null);

  const [FuncionarioId, setFuncionarioId] = useState("");

  const [Nome, setNome] = useState("");

  const [ListaEmpresas, setListaEmpresas] = useState([]);
  const [ListaFucao, setListaFucao] = useState([]);
  const [ShowModalAlocado, setShowModalAlocado] = useState(false);

  const [ShowModalOcorrencia, setShowModalOcorrencia] = useState(false);
  const [ShowModalPermissoes, setShowModalPermissoes] = useState(false);

  const ShowQRDadosFuncionaro = (id) => {
    setFuncionarioId(id);
  };

  const IsContratados = () => {
    if (location.pathname.includes("contratados")) return true;
    if (location.pathname.includes("alocados")) return false;
    return null;
  };

  const DetermineEndpoint = () => {
    if (IsContratados() === true) {
      return empresaId
        ? `/Funcionarios/Contratados/${empresaId}`
        : `/Funcionarios/Contratados`;
    }

    if (IsContratados() === false) {
      return empresaId
        ? `/Funcionarios/Alocados/${empresaId}`
        : `/Funcionarios/Alocados`;
    }
    return "/Funcionarios";
  };

  // Função para determinar a classe do badge baseada no status
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 0:
        return "bg-secondary";
      case 1:
        return "bg-warning";
      case 2:
        return "bg-info";
      case 3:
        return "bg-primary";
      case 4:
        return "bg-success";
      case 5:
        return "bg-danger";
      case 6:
        return "bg-danger";
      case 7:
        return "bg-success";
      case 8:
        return "bg-success";
      default:
        return "bg-secondary";
    }
  };

  // Função para determinar a classe do badge do status do funcionário
  const getStatusFuncionarioBadgeClass = (status) => {
    if (status === "Ativo") return "bg-success";
    if (status === "Desligado") return "bg-danger";
    return "bg-secondary";
  };

  // Função para filtrar dados baseado nos filtros selecionados
  const getFilteredData = () => {
    let filteredData = [...Lista];

    // Filtrar por Status de Cadastro
    if (selectedStatusCadastro.length > 0) {
      filteredData = filteredData.filter(item => 
        selectedStatusCadastro.includes(item.statusCadastro)
      );
    }

    // Filtrar por Status do Funcionário
    if (selectedStatusFuncionario.length > 0) {
      filteredData = filteredData.filter(item => {
        const statusLabel = StatusFuncionario.find(x => x.value === item.status)?.label;
        return selectedStatusFuncionario.includes(statusLabel);
      });
    }

    return filteredData;
  };

  const StateDataPage = async () => {
    try {
      setLoading(true);
      const endpoint = DetermineEndpoint(); // Determina qual endpoint chamar
      const resposta = await Requicicao.Get({
        endpoint,
        config: auth.GetHeaders()
      });
      if (resposta.codigoEstadoHttp === 200) {
        setLista(
          resposta.objetoResposta.sort((a, b) => {
            // Pega a data de atualização ou data de criação, se a atualização for null
            const dataA = new Date(a.dataAtualizacao || a.dataCriacao);
            const dataB = new Date(b.dataAtualizacao || b.dataCriacao);

            // Ordena de forma decrescente (mais recente primeiro)
            return dataB - dataA;
          })
        );

        if (resposta.objetoResposta.length > 0)
          setNome(resposta.objetoResposta[0].empresaContratante);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const InitFilters = () => {
    setFilters(StateDatafilter);
    setGlobalFilterValue("");
    setSelectedStatusCadastro([]);
    setSelectedStatusFuncionario([]);
  };

  const DesativarFuncionario = async (rowData) => {
    try {
      setLoading(true);
      await Requicicao.Delete({
        endpoint: "/Funcionarios",
        params: { id: rowData.id },
        config: auth.GetHeaders()
      });
      notify({
        type: "success",
        message: "Funcionário desativado."
      });
      StateDataPage();
    } catch (error) {
      console.error(error);
      notify({
        type: "error",
        message: "Erro ao desativar o funcionário."
      });
    } finally {
      setLoading(false);
    }
  };

  const Confirm = (event, rowData) => {
    confirmPopup({
      group: "headless",
      target: event.currentTarget,
      message: "Deseja realmente excluir este funcionário?",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      accept: () => DesativarFuncionario(rowData),
      reject: () => {},
      acceptLabel: "Sim",
      rejectLabel: "Não"
    });
  };

  const ReenviarConvite = async (rowData) => {
    try {
      setLoading(true);

      const resposta = await Requicicao.Post({
        endpoint: `/Funcionarios/ReenviarConvite?funcionarioId=${rowData.id}`,
        data: { funcionarioId: rowData.id },
        config: auth.GetHeaders()
      });

      if (resposta.codigoEstadoHttp === 200) {
        notify({
          type: "success",
          message: `Convite reenviado para ${rowData.nome}.`
        });
      } else {
        notify({
          type: "error",
          message: "Erro ao reenviar o convite."
        });
      }
    } catch (error) {
      console.error("Erro ao reenviar o convite:", error);
      notify({
        type: "error",
        message: "Erro ao reenviar o convite."
      });
    } finally {
      setLoading(false);
    }
  };

  const ConfirmReenviar = (event, rowData) => {
    confirmPopup({
      group: "headless",
      target: event.currentTarget,
      message: "Deseja reenviar o convite para este funcionário?",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      accept: () => ReenviarConvite(rowData),
      reject: () => {},
      acceptLabel: "Sim",
      rejectLabel: "Não"
    });
  };

  const ClearFilter = () => {
    InitFilters();
  };

  const onGlobalFilterChange = (e) => {
    try {
      const { value } = e.target;
      const thisFilters = { ...filters };

      thisFilters.global.value = value;

      setFilters(thisFilters);
      setGlobalFilterValue(value);
    } catch (error) {
      console.error(error);
    }
  };

  const GetEmpresas = async () => {
    try {
      const data = await Requicicao.Get({
        endpoint: "/Funcionarios/ObterEmpresas",
        config: auth.GetHeaders()
      });
      if (data.codigoEstadoHttp === 200) {
        setListaEmpresas(data.objetoResposta);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const GetFucao = async () => {
    try {
      const response = await Requicicao.Get({
        endpoint: "/Funcionarios/Funcoes",
        config: auth.GetHeaders()
      });
      if (response.codigoEstadoHttp === 200) {
        const formattedFuncoes = response.objetoResposta.map((funcao) => ({
          label: funcao.descricao,
          id: funcao.id
        }));
        setListaFucao(formattedFuncoes);
      }
    } catch (error) {
      console.error("Erro ao carregar funções:", error);
    }
  };

  const StarteAlocado = async (id) => {
    if (ListaEmpresas.length === 0) await GetEmpresas();
    if (ListaFucao.length === 0) await GetFucao();
    setShowModalAlocado(true);
    setFuncionarioId(id);
  };

  const StarteOcorrencia = (id) => {
    setShowModalOcorrencia(true);
    setFuncionarioId(id);
  };

  const StartePermissoes = (data) => {
    if (data.contaId == null) {
      notify({
        type: "aviso",
        message: "Este funcionário não tem acesso"
      });
    } else {
      setShowModalPermissoes(true);
      setFuncionarioId(data.id);
    }
  };

  const ClosePermissoes = () => {
    setFuncionarioId(null);
    setShowModalPermissoes(false);
  };

  const CriaUser = (data) => {
    setDadosAcesso(data);
    setShowModalNovoAcesso(true);
  };

  // Renderizar ações dos botões
  const renderActions = (rowData) => (
    <div className="d-flex gap-1">
      <Button
        size="small"
        icon="pi pi-pencil"
        className="btn-outline-primary btn-sm"
        onClick={() => navigate(`/app/rh/funcionarios/editar/${rowData.id}`)}
        tooltip="Alterar dados"
        tooltipOptions={{ position: "top", className: "text-xs" }}
      />
      <Button
        size="small"
        icon="bi bi-file-earmark-arrow-up"
        className="btn-outline-secondary btn-sm"
        onClick={() =>
          navigate({
            pathname: "/app/rh/funcionarios/up-arquivo",
            search: createSearchParams({
              id: rowData.id,
              contaId: rowData.contaId
            }).toString()
          })
        }
        tooltip="Documentação"
        tooltipOptions={{ position: "top", className: "text-xs" }}
      />
      {rowData.statusCadastro !== 8 && rowData.statusCadastro !== 5 && (
        <Button
          size="small"
          icon="pi pi-envelope"
          className="btn-outline-info btn-sm"
          onClick={(event) => ConfirmReenviar(event, rowData)}
          tooltip="Reenviar Convite"
          tooltipOptions={{ position: "top", className: "text-xs" }}
          disabled={rowData.statusCadastro === 8 || rowData.statusCadastro === 5}
        />
      )}
      <Button
        size="small"
        icon="pi pi-arrow-right-arrow-left"
        className="btn-outline-warning btn-sm"
        tooltip="Alocação"
        tooltipOptions={{ position: "top", className: "text-xs" }}
        onClick={() => StarteAlocado(rowData.id)}
      />
      <Button
        size="small"
        icon="bi bi-journal-bookmark"
        className="btn-outline-success btn-sm"
        tooltip="Ocorrências"
        tooltipOptions={{ position: "top", className: "text-xs" }}
        onClick={() => StarteOcorrencia(rowData.id)}
      />
      {auth.VerificarAccess([10]) && (
        <Button
          size="small"
          icon="bi bi-shield-check"
          className="btn-outline-danger btn-sm"
          tooltip="Permissões"
          tooltipOptions={{ position: "top", className: "text-xs" }}
          onClick={() => StartePermissoes(rowData)}
        />
      )}
      <Button
        size="small"
        icon="pi pi-user"
        className="btn-outline-dark btn-sm"
        onClick={() => {
          if (rowData.statusCadastro !== 5 && rowData.statusCadastro !== 8) {
            notify({
              type: "aviso",
              message: "Processo de admissão não foi concluído"
            });
          } else {
            CriaUser(rowData);
          }
        }}
        tooltip="Criar acesso para o Funcionário"
        tooltipOptions={{ position: "top", className: "text-xs" }}
      />
      <Button
        size="small"
        icon="pi pi-trash"
        className="btn-outline-danger btn-sm"
        onClick={(event) => Confirm(event, rowData)}
        tooltip="Remover Funcionário"
        tooltipOptions={{ position: "top", className: "text-xs" }}
      />
    </div>
  );

  // Renderizar card do funcionário
  const renderFuncionarioCard = (funcionario) => (
    <div key={funcionario.id} className="col-md-6 col-lg-4 mb-3">
      <div 
        className="card funcionario-card h-100"
        style={styles.funcionarioCard}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = styles.funcionarioCardHover.transform;
          e.currentTarget.style.boxShadow = styles.funcionarioCardHover.boxShadow;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = styles.funcionarioCard.transform;
          e.currentTarget.style.boxShadow = styles.funcionarioCard.boxShadow;
        }}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <h6 className="card-title mb-0">{funcionario.nome}</h6>
            <span 
              className={`badge ${getStatusBadgeClass(funcionario.statusCadastro)}`}
              style={styles.badge}
            >
              {MaskEnum.StatusCadastroFuncionari[funcionario.statusCadastro - 1]}
            </span>
          </div>
          <p className="card-text text-muted small mb-2">
            <i className="pi pi-id-card me-1" />
            {MaskUtil.applyCpfMask(funcionario.cpf)}
          </p>
          <p className="card-text text-muted small mb-2">
            <i className="pi pi-briefcase me-1" />
            {funcionario.funcao || "N/A"}
          </p>
          {funcionario.dataAdmissao && funcionario.dataAdmissao !== "0001-01-01T00:00:00" && (
            <p className="card-text text-muted small mb-2">
              <i className="pi pi-calendar me-1" />
              {format(new Date(funcionario.dataAdmissao), "dd/MM/yyyy")}
            </p>
          )}
          <div className="d-flex gap-1">
            {renderActions(funcionario)}
          </div>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (query.get("filial") != null) {
      setEmpresaId(query.get("filial"));
      setMatriz(query.get("matriz"));
      onGlobalFilterChange({ target: { value: query.get("filtro") } });
    }
  }, [query]);

  useEffect(() => {
    if (auth.isAuthenticated() && empresaId !== "") {
      StateDataPage();
    }
  }, [auth, empresaId]);

  const filteredData = getFilteredData();

  return (
    <>
      <ModalPermissoes
        Close={ClosePermissoes}
        FuncionarioId={FuncionarioId}
        ShowModalPermissoes={ShowModalPermissoes}
        setShowModalPermissoes={setShowModalPermissoes}
      />
      <ModalOcorrencias
        FuncionarioId={FuncionarioId}
        ShowModalOcorrencia={ShowModalOcorrencia}
        setShowModalOcorrencia={setShowModalOcorrencia}
      />
      <ModalAlocacao
        FuncionarioId={FuncionarioId}
        ShowModalAlocado={ShowModalAlocado}
        setShowModalAlocado={setShowModalAlocado}
        ListaEmpresas={ListaEmpresas}
        ListaFucao={ListaFucao}
      />
      <ModalNovoAcesso
        ShowModalNovoAcesso={ShowModalNovoAcesso}
        setShowModallNovoAcesso={setShowModalNovoAcesso}
        Matriz={matriz}
        dados={DadosAcesso}
      />
      <ConfirmPopup group="headless" />
      
      <div className="card p-3">
        {Nome !== "" && <h1 className="fs-3 mb-2">{Nome}</h1>}
        
        {/* Botões de ação principais */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex gap-2">
            {IsContratados() && (
              <>
                <Button
                  type="button"
                  icon="pi pi-user-plus"
                  label="Criar Funcionário"
                  className="btn btn-primary"
                  onClick={() => navigate(`/app/rh/funcionarios/new/${empresaId}`)}
                />
                <Button
                  type="button"
                  icon="pi pi-envelope"
                  label="Criar Convite"
                  className="btn btn-success"
                  onClick={() => navigate(`/app/rh/funcionarios/convite/${empresaId}`)}
                />
              </>
            )}
          </div>
          
          <div className="d-flex align-items-center gap-3">
            {/* Toggle de visualização */}
            <div className="btn-group" role="group">
              <Button
                type="button"
                icon="pi pi-th-large"
                className={`btn ${viewMode === "cards" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setViewMode("cards")}
                tooltip="Visualização em Cards"
              />
              <Button
                type="button"
                icon="pi pi-list"
                className={`btn ${viewMode === "list" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setViewMode("list")}
                tooltip="Visualização em Lista"
              />
            </div>
            
            <Button
              type="button"
              icon="pi pi-filter-slash"
              label="Limpar filtro"
              outlined
              onClick={ClearFilter}
            />
            <span className="p-input-icon-left">
              <i className="pi pi-search me-2" />
              <InputText
                value={globalFilterValue}
                onChange={onGlobalFilterChange}
                placeholder="Pesquisa Global"
                style={{ width: "300px", paddingLeft: "2.5rem" }}
              />
            </span>
          </div>
        </div>

        {/* Filtros Avançados */}
        <div className="mt-3 mb-4">
          <Button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
          >
            <i className={`pi ${showAdvancedFilters ? "pi-chevron-up" : "pi-chevron-down"} me-1`} />
            Filtros Avançados
          </Button>
          
          {showAdvancedFilters && (
            <div className="mt-3 p-3 border rounded bg-light">
              <div className="row">
                {/* Status de Cadastro Filters */}
                <div className="col-md-6">
                  <h6 className="mb-2">
                    <i className="pi pi-file-edit me-2 text-primary" />
                    Status de Cadastro
                  </h6>
                  <div className="d-flex flex-wrap gap-3">
                    {MaskEnum.StatusCadastroFuncionari.map((status, index) => {
                      const isSelected = selectedStatusCadastro.includes(index + 1);
                      const getStatusIcon = (statusIndex) => {
                        switch (statusIndex) {
                          case 1: return "pi pi-plus-circle"; // Cadastro Iniciado
                          case 2: return "pi pi-envelope"; // Convite Enviado
                          case 3: return "pi pi-clock"; // Aguardando Preenchimento
                          case 4: return "pi pi-file-pdf"; // Documentos Submetidos
                          case 5: return "pi pi-check-circle"; // Documentos Aprovados
                          case 6: return "pi pi-exclamation-triangle"; // Documentos Reprovados
                          case 7: return "pi pi-pencil"; // Aguardando Assinatura
                          case 8: return "pi pi-check-square"; // Processo Concluído
                          default: return "pi pi-circle";
                        }
                      };
                      
                                              return (
                          <Button
                            key={`status-cadastro-${index + 1}`}
                            type="button"
                            className={`btn px-3 py-2 ${
                              isSelected
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => {
                              const newSelection = selectedStatusCadastro.includes(index + 1)
                                ? selectedStatusCadastro.filter(s => s !== index + 1)
                                : [...selectedStatusCadastro, index + 1];
                              setSelectedStatusCadastro(newSelection);
                            }}
                          >
                            <i className={`${getStatusIcon(index + 1)} me-2`} />
                            {status}
                          </Button>
                        );
                    })}
                  </div>
                </div>

                {/* Status do Funcionário Filters */}
                <div className="col-md-6">
                  <h6 className="mb-2">
                    <i className="pi pi-user me-2 text-success" />
                    Status do Funcionário
                  </h6>
                  <div className="d-flex flex-wrap gap-3">
                    {StatusFuncionario && StatusFuncionario.length > 0 && StatusFuncionario.map((status) => {
                      const isSelected = selectedStatusFuncionario.includes(status.label);
                      const getStatusIcon = (statusLabel) => {
                        switch (statusLabel) {
                          case "Ativo": return "pi pi-check-circle";
                          case "Desligado": return "pi pi-times-circle";
                          case "Não Contratado": return "pi pi-user-minus";
                          case "Desligamento": return "pi pi-sign-out";
                          case "Doença": return "pi pi-heart";
                          case "Férias": return "pi pi-calendar";
                          case "Licença Maternidade/Paternidade": return "pi pi-home";
                          default: return "pi pi-user";
                        }
                      };
                      
                      return (
                        <Button
                          key={status.value}
                          type="button"
                          className={`btn px-3 py-2 ${
                            isSelected
                              ? "btn-success"
                              : "btn-outline-success"
                          }`}
                          onClick={() => {
                            const newSelection = selectedStatusFuncionario.includes(status.label)
                              ? selectedStatusFuncionario.filter(s => s !== status.label)
                              : [...selectedStatusFuncionario, status.label];
                            setSelectedStatusFuncionario(newSelection);
                          }}
                        >
                          <i className={`${getStatusIcon(status.label)} me-2`} />
                          {status.label}
                        </Button>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Clear Filters Button */}
              {(selectedStatusCadastro.length > 0 || selectedStatusFuncionario.length > 0) && (
                <div className="mt-3 pt-3 border-top">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <i className="pi pi-filter text-muted me-2" />
                      <small className="text-muted">
                        {selectedStatusCadastro.length + selectedStatusFuncionario.length} filtro(s) ativo(s)
                      </small>
                    </div>
                    <Button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => {
                        setSelectedStatusCadastro([]);
                        setSelectedStatusFuncionario([]);
                      }}
                    >
                      <i className="pi pi-times me-1" />
                      Limpar Filtros
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Seção: Processo Concluído */}
        {(() => {
          const funcionariosConcluidos = filteredData.filter(f => f.statusCadastro === 8);
          if (funcionariosConcluidos.length === 0) return null;
          
          return (
            <div className="secao-funcionarios mb-4">
              <div className="secao-header bg-success text-white p-3 rounded-top">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h5 className="mb-0">
                      <i className="pi pi-check-circle me-2" />
                      Processo Concluído
                    </h5>
                    <small className="opacity-75">
                      {funcionariosConcluidos.length} funcionário{funcionariosConcluidos.length !== 1 ? 's' : ''}
                    </small>
                  </div>
                  <div className="d-flex gap-2">
                    {(() => {
                      const ativos = funcionariosConcluidos.filter(f => f.status === 0).length;
                      const inativos = funcionariosConcluidos.filter(f => f.status === 1).length;
                      const outros = funcionariosConcluidos.length - ativos - inativos;
                      
                      return (
                        <>
                          {ativos > 0 && (
                            <span className="badge bg-light text-success">
                              {ativos} Ativo{ativos !== 1 ? 's' : ''}
                            </span>
                          )}
                          {inativos > 0 && (
                            <span className="badge bg-light text-danger">
                              {inativos} Inativo{inativos !== 1 ? 's' : ''}
                            </span>
                          )}
                          {outros > 0 && (
                            <span className="badge bg-light text-secondary">
                              {outros} Outro{outros !== 1 ? 's' : ''}
                            </span>
                          )}
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
              <div className="secao-content p-3 bg-light rounded-bottom">
                {viewMode === "cards" ? (
                  <div className="row">
                    {funcionariosConcluidos.map(renderFuncionarioCard)}
                  </div>
                ) : (
        <DataTable
                    value={funcionariosConcluidos}
          stripedRows
          paginator
                    rows={10}
          emptyMessage="Nenhum funcionário encontrado."
                    globalFilterFields={["nome", "cpf", "funcao", "empresaContratante", "empresaAlocacao"]}
          filters={filters}
                    tableStyle={{ minWidth: "50rem" }}
                  >
                    <Column field="nome" header="Nome" sortable style={{ width: "23%" }} />
                    <Column
                      field="cpf"
                      header="CPF"
                      sortable
                      body={(row) => MaskUtil.applyCpfMask(row.cpf)}
                      style={{ width: "15%" }}
                    />
                    <Column field="funcao" header="Função" sortable style={{ width: "18%" }} />
          <Column
            field="statusCadastro"
                      header="Status de Cadastro"
            sortable
                      body={(row) => (
                        <span 
                          className={`badge ${getStatusBadgeClass(row.statusCadastro)}`}
                          style={styles.badge}
                        >
                          {MaskEnum.StatusCadastroFuncionari[row.statusCadastro - 1]}
                        </span>
                      )}
                      style={{ width: "12%" }}
          />
          <Column
            field="status"
            header="Status do Funcionário"
                          body={(rowData) => {
                            const statusLabel = rowData.status != null
                              ? StatusFuncionario.find((x) => x.value === rowData.status)?.label
                              : "";
                            return (
                              <span 
                                className={`badge ${getStatusFuncionarioBadgeClass(statusLabel)}`}
                                style={styles.badge}
                              >
                                {statusLabel}
                              </span>
                            );
                          }}
                          style={{ width: "20%" }}
                        />
          <Column
            field="dataAdmissao"
            header="Data de Admissão"
            sortable
            body={({ dataAdmissao }) =>
              dataAdmissao && dataAdmissao !== "0001-01-01T00:00:00"
                ? format(new Date(dataAdmissao), "dd/MM/yyyy")
                : ""
            }
                      style={{ width: "15%" }}
                    />
                    <Column header="Ações" body={renderActions} style={{ width: "6%" }} />
                  </DataTable>
                )}
              </div>
            </div>
          );
        })()}

        {/* Seção: Em Processo */}
        {(() => {
          const funcionariosEmProcesso = filteredData.filter(f => f.statusCadastro !== 8);
          if (funcionariosEmProcesso.length === 0) return null;
          
          // Agrupar por status de cadastro
          const grupos = {};
          funcionariosEmProcesso.forEach(f => {
            const statusLabel = MaskEnum.StatusCadastroFuncionari[f.statusCadastro - 1] || "Não definido";
            if (!grupos[statusLabel]) grupos[statusLabel] = [];
            grupos[statusLabel].push(f);
          });
          
          return (
            <div className="secao-funcionarios mb-4">
              <div className="secao-header bg-warning text-dark p-3 rounded-top">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h5 className="mb-0">
                      <i className="pi pi-clock me-2" />
                      Em Processo
                    </h5>
                    <small className="opacity-75">
                      {funcionariosEmProcesso.length} funcionário{funcionariosEmProcesso.length !== 1 ? 's' : ''}
                    </small>
                  </div>
                </div>
              </div>
              <div className="secao-content p-3 bg-light rounded-bottom">
                {viewMode === "cards" ? (
                  Object.entries(grupos).map(([statusLabel, funcionarios]) => (
                    <div key={statusLabel} className="grupo-status mb-4">
                      <div className="grupo-header d-flex align-items-center mb-3">
                        <h6 className="mb-0 me-3">{statusLabel}</h6>
                        <span className="badge bg-secondary">{funcionarios.length}</span>
                      </div>
                      <div className="row">
                        {funcionarios.map(renderFuncionarioCard)}
                      </div>
                    </div>
                  ))
                ) : (
                  Object.entries(grupos).map(([statusLabel, funcionarios]) => (
                    <div key={statusLabel} className="grupo-status mb-4">
                      <div className="grupo-header d-flex align-items-center mb-3">
                        <h6 className="mb-0 me-3 fw-bold">{statusLabel}</h6>
                        <span className="badge bg-secondary">{funcionarios.length}</span>
                      </div>
                                              <DataTable
                          value={funcionarios}
                          stripedRows
                          paginator
                          rows={10}
                          emptyMessage="Nenhum funcionário encontrado."
                          globalFilterFields={["nome", "cpf", "funcao", "empresaContratante", "empresaAlocacao"]}
                          filters={filters}
                          tableStyle={{ minWidth: "50rem" }}
                        >
                          <Column field="nome" header="Nome" sortable style={{ width: "20%" }} />
                          <Column
                            field="cpf"
                            header="CPF"
                            sortable
                            body={(row) => MaskUtil.applyCpfMask(row.cpf)}
                            style={{ width: "15%" }}
                          />
                          <Column field="funcao" header="Função" sortable style={{ width: "15%" }} />
                          <Column
                            field="statusCadastro"
                            header="Status de Cadastro"
                            sortable
                            body={(row) => (
                              <span 
                                className={`badge ${getStatusBadgeClass(row.statusCadastro)}`}
                                style={styles.badge}
                              >
                                {MaskEnum.StatusCadastroFuncionari[row.statusCadastro - 1]}
                              </span>
                            )}
                            style={{ width: "20%" }}
                          />
                          <Column
                            field="dataAdmissao"
                            header="Data de Admissão"
                            sortable
                            body={({ dataAdmissao }) =>
                              dataAdmissao && dataAdmissao !== "0001-01-01T00:00:00"
                                ? format(new Date(dataAdmissao), "dd/MM/yyyy")
                                : ""
                            }
                            style={{ width: "15%" }}
                          />
                          <Column header="Ações" body={renderActions} style={{ width: "15%" }} />
                        </DataTable>
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })()}

        {/* Mensagem quando não há dados */}
        {Lista.length === 0 && (
          <div className="text-center py-5">
            <i className="pi pi-users text-muted" style={{ fontSize: "3rem" }} />
            <h5 className="text-muted mt-3">Nenhum funcionário encontrado</h5>
            <p className="text-muted">Não há funcionários para exibir com os filtros atuais.</p>
              </div>
            )}
      </div>
    </>
  );
};

export default ListaFuncionarioContratadosAlocados;
